import { z } from 'zod/v4';

export const UPSELL_FEATURE = [
  'automations',
  'tasks',
  'analytics',
  'reports',
  'mails',
  'externalmailbox',
  'aicalls',
  'paymentplans',
] as const;

export type UpsellFeature = (typeof UPSELL_FEATURE)[number];

export const UpsellFeatureSchema = z.enum([...UPSELL_FEATURE]);
